// extracted by mini-css-extract-plugin
export default {"profileImage":"FullNameAvatar_profileImage__STQMW","fullName":"FullNameAvatar_fullName__PyQTO"};